export interface Song {
  title: string
  /** Omit for tracks that haven't been released yet */
  url?: string
}

export const honorableMusicYouTube =
  'https://www.youtube.com/@honorable758?sub_confirmation=1'

export const honorableMusicSongs: Song[] = [
  {
    title: 'Bon Maten',
    url: 'https://cdn.magicpatterns.com/uploads/7Nvo7h2uatdEDiSsEoGd3d/Bon_Maten_-_Honorable_Music-_%5BOfficial%5D.mp3',
  },
  {
    title: 'Marry Warna',
    url: 'https://cdn.magicpatterns.com/uploads/f8hSdJxNNoQCKWqoBMhbMJ/I_want_to_Marry_Warna_%5BHonorable_Music%5D.mp3',
  },
  {
    title: 'Bois Den Tea',
    url: 'https://cdn.magicpatterns.com/uploads/ws7b6RAeDfPLL7FaCV7gTP/Bois_Den_TEA_-_Honorable_Music.mp3',
  },
  {
    title: 'Shock in Court',
    url: 'https://cdn.magicpatterns.com/uploads/fU9if3BWVnpMnCyvP1XGNQ/Shock_In_Court-_Honorable_Music.mp3',
  },
  { title: 'Mujay Byla Douvan' },
  { title: 'Flower Competition' },
  { title: 'She Must Come Back' },
  { title: 'Only Thing I Can Do Is Watch' },
  { title: 'My Wife, My Girlfriend, My Lover' },
]
